<template>
    <div class="form-item">
        <label class="label-caption">Situação Parcela</label>
        <select :value="statusSelecionado" @change="atualizarStatus" class="form-control" v-bind="$attrs">
            <option v-for="tipo in lsStatus" :key="tipo.id" :value="tipo.id">{{ tipo.descricao }}</option>
        </select>
    </div>
</template>
  
<script>
export default {
    props: {
        statusSelecionado: {type: Number, default: null}
    },

    data() {
        return{
            lsStatus:[
                {id: 0, descricao: 'TODAS'},
                {id: 1, descricao: 'AGUARDANDO EMISSÃO'},
                {id: 3, descricao: 'À RECEBER'},
                {id: 5, descricao: 'RECEBIDA'}
            ]
        };
    },

    methods: {
        atualizarStatus(event) {
            this.$emit('update:statusSelecionado', Number(event.target.value));
        }
    }
};
</script>